var React = require('react');

function AerHousehold1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m104.8 222.125h19.859 15.519 17.022 65.5v-104.471h39.3l-131-117.529-131 117.529h39.3v104.471z","fill":"#ffb432","key":0}),React.createElement("path",{"clipRule":"evenodd","d":"m144 88.125c0 7.1797-5.82 13-13 13s-13-5.8203-13-13 5.82-13 13-13 13 5.8203 13 13zm-37 28c0-4.418 3.582-8 8-8h32c4.418 0 8 3.582 8 8v48c0 4.418-3.582 8-8 8h-3v50h-26v-50h-3c-4.418 0-8-3.582-8-8z","fill":"#232323","fillRule":"evenodd","key":1})]);
}

AerHousehold1.defaultProps = {"fill":"none","height":"223","viewBox":"0 0 262 223","width":"262"};

module.exports = AerHousehold1;

AerHousehold1.default = AerHousehold1;
